<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-14",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 14,
      nextPage: '/questionnaire/section1/15',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Lactation.png'),
        mainTitle: 'Which of the following is your method of delivery?',
        btn: [
          [
            {
              text: 'Natural Labour',
            },{
              text: 'Cesarean Section',
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
